module.exports = __webpack_public_path__ + "img/ysblogo12.438bb37f.png";